/* global SideDrawer */

class OffersDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:offers-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:offers-drawer:close', this.closeDrawerViaEventHandler);
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:offers-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:offers-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }
}

window.customElements.define('offers-drawer', OffersDrawer);

